import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileViewProgress } from './MobileViewProgress';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-canvas text-fg">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <MobileViewProgress />
    </div>
  );
}
